module.exports = __webpack_public_path__ + "static/media/tracking.a66afb61.svg";